import { get } from 'lodash-es';

import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import type { RateViewerInstanceState, RateViewerProviderRate, RateViewerSelectedRate, RateViewerState } from './rate-viewer.types';
import type { RootState } from 'store/root-state';

export const AllInstances = (state: RateViewerState): Record<string, RateViewerInstanceState> => get(state, 'instances', emptyObject);
const Instance = (state: RateViewerState, { rateViewerKey }: { rateViewerKey: string }): RateViewerInstanceState =>
  get(AllInstances(state), rateViewerKey, emptyObject);
export const IsLoading = (state: RateViewerState, props: { rateViewerKey: string }): boolean =>
  get(Instance(state, props), 'isLoading', false);
export const Rates = (state: RateViewerState, props: { rateViewerKey: string }): readonly RateViewerProviderRate[] =>
  get(Instance(state, props), 'rates', emptyArray);
export const Errors = (state: RateViewerState, props: { rateViewerKey: string }): readonly string[] =>
  get(Instance(state, props), 'errors', emptyArray);
export const SellerProviderId = (state: RateViewerState, props: { rateViewerKey: string }): string | undefined =>
  get(Instance(state, props), 'selectedSellerProviderId');
export const Rate = (state: RateViewerState, props: { rateViewerKey: string }): RateViewerSelectedRate | undefined =>
  get(Instance(state, props), 'selectedRate', undefined);

export const selectRateViewerAllInstances = (state: RootState): Record<string, RateViewerInstanceState> =>
  AllInstances(get(state, 'rateViewer'));
export const selectRateViewerIsLoading = (state: RootState, props: { rateViewerKey: string }): boolean =>
  IsLoading(get(state, 'rateViewer'), props);
export const selectRateViewerRates = (state: RootState, props: { rateViewerKey: string }): readonly RateViewerProviderRate[] =>
  Rates(get(state, 'rateViewer'), props);
export const selectRateViewerErrors = (state: RootState, props: { rateViewerKey: string }): readonly string[] =>
  Errors(get(state, 'rateViewer'), props);
export const selectRateViewerSellerProviderId = (state: RootState, props: { rateViewerKey: string }): string | undefined =>
  SellerProviderId(get(state, 'rateViewer'), props);
export const selectRateViewerRate = (state: RootState, props: { rateViewerKey: string }): RateViewerSelectedRate | undefined =>
  Rate(get(state, 'rateViewer'), props);
